// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2W-h0","list":"BalanceDue_list__3jvmV","listRow":"BalanceDue_listRow__1h7BL","total":"BalanceDue_total__2f4sA"};